/**
 *  @class
 *  @function SlideShow
 */
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this;
      const hasVideo = slideshow.classList.contains('slideshow-video');
      let oldIndex = 0;

      let dots = slideshow.dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
        align = slideshow.dataset.align == 'center' ? 'center' : 'left',
        fade = slideshow.dataset.fade == 'true' ? true : false,
        prev_button = slideshow.querySelector('.flickity-prev') ?? slideshow.closest('.shopify-section')?.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next') ?? slideshow.closest('.shopify-section')?.querySelector('.flickity-next'),
        custom_dots = slideshow.querySelector('.flickity-page-dots'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        progress_bar_type = 'scrollbar', /*comment this argument for default*/
        pbwidth = 25,
        animations = [],
        rightToLeft = document.dir === 'rtl',
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
        selectedIndex = 0,
        args = {
          wrapAround: true,
          cellAlign: align,
          pageDots: false,
          contain: true,
          freeScroll: slideshow.dataset.freeScroll === 'true',
          fade: fade,
          autoPlay: autoplay,
          rightToLeft: rightToLeft,
          prevNextButtons: false,
          groupCells: (slideshow.dataset.groupCells || false),
          cellSelector: '.carousel__slide',
          on: {}
        };

      if (slideshow_slides.length < 1) {
        return;
      }
      if (slideshow.classList.contains('image-with-text-slideshow__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow__content'),
          image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow__image-media');
        args.draggable = false;
        args.asNavFor = main_slideshow;

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (slideshow.classList.contains('customer-reviews__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.customer-reviews__content');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('featured-collection-list--bg')) {
        let main_slideshow = slideshow.parentNode.querySelector('.featured-collection-list--inner--content');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('image-with-text-slideshow__content') ||
        slideshow.classList.contains('testimonials__carousel') ||
        slideshow.classList.contains('customer-reviews__content') ||
        slideshow.classList.contains('customer-reviews__image')) {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains('custom-dots') || hasVideo) {

        if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
          this.prepareAnimations(slideshow, animations);
        }
        args.pauseAutoPlayOnHover = false;

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;
            // Animations.
            if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
              slideshow.animateSlides(0, animations);
              gsap.set(slideshow.querySelectorAll('.subheading,.split-text,.button'), { visibility: 'visible' });
            }

            // Custom Dots.
            if (dots && custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.addEventListener('click', (e) => {
                  flkty.select(i);
                });
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }
            document.fonts.ready.then(function () {
              flkty.resize();
            });

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.slideshow__slide-video');
            if (video_container) {

              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function () {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function () {
                  slideshow.videoPlay(video_container);
                };

                video_container.querySelector('.icon-play')?.addEventListener('click', (e) => {
                  if(video_container.querySelector('video').classList.contains('playing')){
                    slideshow.videoPause(video_container);
                  } else {
                    slideshow.videoPlay(video_container);
                  }
                });
              }

              /*stop slider autochange timer till video completes*/
              slideshow.syncAutoplay(flkty, video_container, autoplay);
            }
          },
          change: function (index) {
            /*
              - previousIndex (theme default) : the index of the leftside element.
                It is previous selected element on forward direction, like change from 1 to 2 - will show '1'.
                But on 'backward' will show incorrect number. When change from 2 to 1, will show '0' instead of '2'.
                It is used to keep the animation like in theme default.
              - oldIndex (correction of previousIndex) : the index of 'previous selected' element on both directions (forward or backward), and also when jump from first to last/last to first
            */
            let previousIndex = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);

            let lastIndex = this.slides.length - 1;
            let direction = (index > oldIndex) ? 'forward' : 'backward';
            if(index == 0 && oldIndex == lastIndex && lastIndex > 1){
              direction = 'forward'; /*loop from last to first */
            }
            if(oldIndex == 0 && index == lastIndex && lastIndex > 1){
              direction = 'backward'; /*loop from first to last */
            }

            // Animations.
            if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
              setTimeout(() => {
                slideshow.animateReverse(previousIndex, animations);
              }, 300);
              slideshow.animateSlides(index, animations);
            }

            // Custom Dots.
            if (dots && custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.classList.remove('is-selected');
              });
              dots[this.selectedIndex].classList.add('is-selected');
            }

            // AutoPlay
            //if (autoplay) {
            //  this.stopPlayer();
            //  this.playPlayer();
            //}

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[oldIndex].element.querySelector('.slideshow__slide-video');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }
            slideshow.syncAutoplay(this, video_container, autoplay);

            oldIndex = index;
          }
        };
      }
      if (slideshow.classList.contains('main-slideshow')) {
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }
      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on.ready = function () {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize', function () {
              slideshow.centerArrows(flickity, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize'));
        };
      }
      if (progress_bar) {
        if(progress_bar_type == 'scrollbar'){
            progress_bar.style.width = pbwidth + '%';
        }

        args.wrapAround = false;
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          if(progress_bar_type == 'scrollbar'){
            progress_bar.style.transform = 'translateX(' + (((100/pbwidth)-1) * progress * 100) + '%)';
          } else {
            progress_bar.style.width = progress * 100 + '%';
          }
        };
      }
      if (slideshow.classList.contains('no-infinity')) {
        args.wrapAround = false;
      }
      const flkty = new Flickity(slideshow, args);

      selectedIndex = flkty.selectedIndex;

      slideshow.dataset.initiated = true;

      if(slideshow.classList.contains('update-tabindex')){
        flkty.on('change', function(index) {
          slideshow.updateAriaHidden();
        });
      }

      if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          flkty.previous();
        });
        prev_button.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ENTER' || event.code.toUpperCase() === 'SPACE' || event.keyCode == 13) {
            flkty.previous();
          }
        });
        next_button.addEventListener('click', (event) => {
          flkty.next();
        });
        next_button.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ENTER' || event.code.toUpperCase() === 'SPACE' || event.keyCode == 13) {
            flkty.next();
          }
        });
      }
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

    }
    videoPause(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video').pause();
          video_container.querySelector('video').classList.remove('playing');
        } else if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: ""
          }), "*");
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "pause"
          }), "*");
        }
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video').play();
          video_container.querySelector('video').classList.add('playing');
        } else if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "play"
          }), "*");
        }
      }, 10);
    }
    /*custom video methods - waits inslide video to finish before autochanging slide*/
    // Returns a cancel function, or null if there's nothing to wait for
    // (no playable video, or the video is set to loop).
    watchVideoEnd(video_container, callback) {
      const provider = video_container.dataset.provider;
      const video = video_container.querySelector('video');
      const iframe = video_container.querySelector('iframe');
      let done = false;
      let cleanup = () => {};
    
      const finish = () => {
        if (done) return;
        done = true;
        cleanup();
        callback();
      };
    
      if (provider === 'hosted' && video) {
        if (video.loop) return null; // never ends, fall back to normal slider timer
        video.addEventListener('ended', finish);
        cleanup = () => video.removeEventListener('ended', finish);
      } else if (iframe && (provider === 'youtube' || provider === 'vimeo')) {
        const subscribe = () => {
          if (!iframe.contentWindow) return;
          if (provider === 'youtube') {
            iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1, channel: 'widget' }), '*');
          } else {
            iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'finish' }), '*');
          }
        };
        const onMessage = (e) => {
          if (e.source !== iframe.contentWindow) return;
          let data = e.data;
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (err) { return; }
          }
          if (!data) return;
          if (provider === 'youtube' &&
            ((data.event === 'onStateChange' && data.info === 0) ||
             (data.event === 'infoDelivery' && data.info && data.info.playerState === 0))) {
            finish();
          }
          if (provider === 'vimeo' && data.event === 'finish') {
            finish();
          }
        };
        window.addEventListener('message', onMessage);
        iframe.addEventListener('load', subscribe); // covers lazyloaded iframes
        subscribe();
        cleanup = () => {
          window.removeEventListener('message', onMessage);
          iframe.removeEventListener('load', subscribe);
        };
      } else {
        return null;
      }
    
      return () => { done = true; cleanup(); };
    }
    
    // Call after every slide change (and on ready).
    syncAutoplay(flkty, video_container, autoplay) {
      if (this._cancelVideoWait) {
        this._cancelVideoWait();
        this._cancelVideoWait = null;
      }
      if (!autoplay) return;
    
      flkty.stopPlayer();
      const cancel = video_container
        ? this.watchVideoEnd(video_container, () => flkty.next())
        : null;
    
      if (cancel) {
        this._cancelVideoWait = cancel; // wait for video to finish
      } else {
        flkty.playPlayer();             // no video: normal timer
      }
    }
    /*end custom video methods*/
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        new SplitText(slideshow.querySelectorAll('h1, p:not(.subheading)'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });
        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({
            paused: true
          }),
            button_offset = 0;

          animations[i] = tl;

          if (slideshow.dataset.transition == 'swipe') {
            tl
              .to(item, {
                duration: item.classList.contains('is-initial-selected') ? 0.2 : 0.7,
                clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)"
              }, "start");
          }
          tl
            .to(item.querySelector('.slideshow__slide-bg'), {
              duration: 1.5,
              scale: 1
            }, "start");

          if (item.querySelector('.subheading')) {
            tl
              .to(item.querySelector('.subheading'), {
                duration: 0.5,
                autoAlpha: 1
              }, 0);

            button_offset += 0.5;
          }
          if (item.querySelector('h1')) {
            let h1_duration = 0.5 + ((item.querySelectorAll('h1 .line-child div').length - 1) * 0.05);
            tl
              .from(item.querySelectorAll('h1 .line-child div'), {
                duration: h1_duration,
                yPercent: '100',
                stagger: 0.05
              }, 0);
            button_offset += h1_duration;
          }
          if (item.querySelector('p:not(.subheading)')) {

            let p_duration = 0.5 + ((item.querySelectorAll('p:not(.subheading) .line-child div').length - 1) * 0.02);
            tl
              .from(item.querySelectorAll('p:not(.subheading) .line-child div'), {
                duration: p_duration,
                yPercent: '100',
                stagger: 0.02
              }, 0);
            button_offset += p_duration;
          }
          if (item.querySelectorAll('.button')) {
            tl
              .fromTo(item.querySelectorAll('.button'), {
                y: '100%'
              }, {
                duration: 0.5,
                y: '0%',
                stagger: 0.1,
              }, button_offset * 0.2);
          }
          item.dataset.timeline = tl;
        });
        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, animations) {
      document.fonts.ready.then(function () {
        animations[i].timeScale(1).restart();
      });
    }
    animateReverse(i, animations) {
      animations[i].timeScale(3).reverse();
    }
    centerArrows(flickity, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,

        image_height = first_cell.element.querySelector('.product-featured-image').clientHeight;

      flickity.cells.forEach((item, i) => {
        if (item.size.height > max_height) {
          max_height = item.size.height;
        }
      });


      if (max_height > image_height) {
        let difference = (max_height - image_height) / -2;

        prev_button.style.transform = 'translateY(' + difference + 'px)';
        next_button.style.transform = 'translateY(' + difference + 'px)';
      }
    }
    updateAriaHidden(){
      this.querySelectorAll('.carousel__slide a, .carousel__slide button').forEach((item) => {
        item.setAttribute('tabindex','-1');
      });
      this.querySelectorAll('.carousel__slide.is-selected a, .carousel__slide.is-selected button').forEach((item) => {
        item.setAttribute('tabindex','0');
      });
    }
  }

if (!customElements.get('slide-show')) {
  customElements.define('slide-show', SlideShow);
}